module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_keji@3x (1).9525360b.png";